'use client'

import { ReactNode } from 'react'
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SortEnum } from '@/enums'
import { cn } from '@/lib/utils'

type PropsType = {
  children: ReactNode
  sortBy?: string
  currentSortBy?: string
  currentSort?: SortEnum
  onSort: (sortBy: string, sort: SortEnum) => void
  className?: string
}

const SortableHeader = ({ children, sortBy, currentSortBy, currentSort, onSort, className }: PropsType) => {
  if (!sortBy) {
    return <span className={cn('font-medium', className)}>{children}</span>
  }

  const isActive = currentSortBy === sortBy
  const nextSort = isActive && currentSort === SortEnum.ASC ? SortEnum.DESC : SortEnum.ASC

  const getSortIcon = () => {
    if (!isActive) {
      return <ArrowUpDownIcon className="ml-2 h-4 w-4" />
    }
    return currentSort === SortEnum.ASC ? (
      <ArrowUpIcon className="ml-2 h-4 w-4" />
    ) : (
      <ArrowDownIcon className="ml-2 h-4 w-4" />
    )
  }

  return (
    <Button
      variant="ghost"
      onClick={() => onSort(sortBy, nextSort)}
      className={cn('h-auto p-0 font-medium hover:bg-transparent', className)}>
      {children}
      {getSortIcon()}
    </Button>
  )
}

export default SortableHeader
